<template>
  <div id="main-content">
    <div style="display: flex;background: #FFFFFF;padding: 10px;cursor: pointer">
      <div class="my-group">
        <div class="my-group-item my-group-item-left" :class="type==='month'?'active':''" @click="type='month'">月汇率</div>
        <div class="my-group-item my-group-item-right" :class="type==='day'?'active':''"  @click="type='day'">日汇率</div>
      </div>
      <div style="margin-left: 10px;">
        <a-date-picker
          v-model="day"
          valueFormat="YYYY-MM-DD"
          @change="getList()" />
      </div>
      <div style="flex: 1"></div>
      <div class="my-button" @click="addView" v-if="type==='month'">
        添加
      </div>
    </div>
    <div class="gb-table-panel" style="margin-top: 10px;background: #FFFFFF;">
      <div class="gb-table-content" >
        <div class="gb-table-list" style="background: #E5E5E5;position: absolute;top:0px;">
          <div class="gb-table-item">币种</div>
          <div class="gb-table-item">金额</div>
          <div class="gb-table-item">日期</div>
        </div>
        <div class="gb-table-list" v-for="(dataItem,dataIndex) in  dataList">
          <div class="gb-table-item">{{dataItem.currency}}</div>
          <div class="gb-table-item" v-if="type==='day'">{{dataItem.value}}</div>
          <div class="gb-table-item" v-else @click="addView(dataItem)">{{dataItem.value}}</div>
          <div class="gb-table-item">{{dataItem[type==='month'?'month':'date']}}</div>
        </div>
      </div>
    </div>
    <a-modal :visible="showDialog" :mask="false" title="调整汇率" @ok="addInfo" @cancel="showDialog=false">
      <a-form layout="inline">
        <a-form-item label="日期">
          <a-date-picker
            v-model="baseInfo.month"
            valueFormat="YYYY-MM-01" />
        </a-form-item>
        <a-form-item label="币种">
          <a-input v-model="baseInfo.currency"></a-input>
        </a-form-item>
        <a-form-item label="金额" >
          <span style="color: red">1$ = </span>
          <a-input-number v-model="baseInfo.money"></a-input-number>
          {{baseInfo.currency}}
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {AddExchangeRate, GetExchangeRateList} from "../../api/v1/home_api";

export default {
  name: "Index",
  data(){
    return {
      type:'month',
      dataList:[],
      day:'',
      showDialog:false,
      baseInfo:{
        day:'',
        currency:'',
        money:1
      }
    }
  },
  watch:{
    type:{
      handler:function (val,oldVal) {
        this.dataList = []
        this.getList()
      }
    }
  },
  mounted() {
    this.day = this._get_current_date(3)
    this.getList()
  },
  methods: {
    getList(){
      GetExchangeRateList({type:this.type,day:this.day}).then(resp => {
        if (resp.code===200){
          this.dataList = resp.data
        }
      })
    },
    addView(dataItem={}){
      if (Object.values(dataItem).length!==0){
        this.baseInfo = {
          currency: dataItem.currency,
          month: dataItem.month,
          money: dataItem.value
        }
      }else{
        this.baseInfo = {
          currency: '',
          month: '',
          money: 1
        }
      }
      this.showDialog = true
    },
    addInfo(){
      AddExchangeRate(this.baseInfo).then(resp => {
        this.showDialog = false
        if (resp.code===200){
          this.$message.success("汇率调整成功")
          this.getList()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ExchangeRate/Index.vue